(function() {
    'use strict';

    var upload;

    angular
        .module('lingoda')
        .directive('fileModel', fileModel)
        .directive('fieldMediaUpload', mediaUpload);

    function fileModel() {
        return {
            restrict: 'A',
            scope: {
                fileModel: '&',
            },
            link: function(scope, element) {
                element.bind('change', function(changeEvent) {
                    scope.$apply(function() {
                        scope.fileModel = changeEvent.target.files[0];

                        upload(scope.fileModel);
                    });
                });
            },
        };
    }

    mediaUpload.$inject = ['$http'];
    function mediaUpload($http) {
        return {
            restrict: 'A',
            template: function() {
                return [
                    '<input type="file" ng-if="!model" data-file-model="input"/>',
                    '<div ng-if="media">',
                    '{{ media.name }}',
                    '</div>',
                ].join('');
            },
            scope: {
                model: '=',
            },
            link: function(scope, element, attrs) {
                scope.input = null;

                upload = function(file) {
                    var fd = new FormData();
                    fd.append('options', attrs.options);
                    fd.append('media[binaryContent]', file);
                    $http
                        .post(attrs.uploadUrl, fd, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined },
                        })
                        .success(function(response) {
                            scope.media = response.data;
                            scope.model = response.data.id;
                        })
                        .error(function() {
                            // Show error
                        });
                };
            },
        };
    }
})();
